<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:46:40
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 16:11:36
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/remark/remark.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-align-center">
		<RdText v-if="row.remark">
			{{ row.remark }}
		</RdText>
		<div v-else>-</div>
		<el-popover placement="right" width="400" trigger="manual" v-model="editRemarkVisible">
			<div class="p-12">
				<el-input type="textarea" v-model="editRemark" placeholder="请输入备注内容" maxlength="500" rows="5" show-word-limit></el-input>
				<div class="flex-row flex-just-end mt-20">
					<el-button @click="editRemarkVisible = false">取消</el-button>
					<el-button @click="handleEditRemark" type="primary">确认</el-button>
				</div>
			</div>
			<div slot="reference">
				<i
					@click="handleShowEditRemark"
					class="el-icon-edit-outline fz-14 cursor-pointer yx-color-primary"
					:class="{ 'table-class': row.visible && $auth.hasPermi('edit:local-material') }"
				></i>
			</div>
		</el-popover>
	</div>
</template>
<script>
import { updateMaterialRemark } from '@/api/contentLibray/'
export default {
	props: {
		row: {
			type: Object,
			default: () => ({}),
		},
		isHover: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			editRemarkVisible: false,
			editRemark: '',
		};
	},
	methods: {
		handleShowEditRemark() {
			this.editRemarkVisible = true;
			this.editRemark = this.row.remark;
		},
		async handleEditRemark() {
			const params = {
				id: this.row.id,
				remark: this.editRemark,
			};
			await updateMaterialRemark(params);
			this.$set(this.row, 'remark', this.editRemark);
			this.editRemarkVisible = false;
		},
	},
};
</script>
<style lang="less" scoped>
i.el-icon-edit-outline {
	visibility: hidden;
	&.table-class {
		visibility: visible;
	}
}
</style>